import { render, staticRenderFns } from "./IntentAnswer.vue?vue&type=template&id=1a399c91&scoped=true&"
import script from "./IntentAnswer.vue?vue&type=script&lang=js&"
export * from "./IntentAnswer.vue?vue&type=script&lang=js&"
import style0 from "./IntentAnswer.vue?vue&type=style&index=0&id=1a399c91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a399c91",
  null
  
)

export default component.exports